import { Package, PackageHost } from '../../Container';
import { inContentProcessors } from '../../canvas/injection/ContentInjector';
import { ComputeController } from './ComputeController';
import { inControlsCommands } from './ControlsCommands';
import { ControlsMechanics } from './ControlsMechanics';
import { LinkProcessor } from './LinkProcessor';
import { inSmartContainerCommands } from './SmartContainerCommands';
import { TextGeneratorMechanics } from './TextGeneratorMechanics';

export class ControlsPackage implements Package {

    public install = (host: PackageHost) => host
        .register(ComputeController, 'singleton', 'startable')
        .register(ControlsMechanics, 'singleton', 'startable')
        .register(TextGeneratorMechanics, 'singleton', 'startable')
        .plug(inControlsCommands())
        .plug(inSmartContainerCommands())
        .plug(inContentProcessors(LinkProcessor))
        ;
}
